
export const oauth = {
    processingGoogleLogin: '正在处理Google登录...',
    redirecting: '正在跳转...'
  };
